import React from 'react';


const Boutons = ( {retour, suivant, valide, callback} ) => {
 
    return (
        <div className="container" style={{ marginTop: "40px" }}>
            <div className= "row">
                <div className="col-xs-6 text-center">
                    { retour && (
                        <button type="button" className="btn btn-primary" onClick={ () => callback({type:"retour", cible: retour })}>Retour</button>
                    )}
                </div>
                <div className="col-xs-6 text-center">
                    { suivant && (
                        <div className="boutonsuivant">
                            { valide && (<button type="button" className="btn btn-primary" onClick={ () => callback({type:"suivant", cible: suivant })}>Suivant</button>)}
                            { !valide && (<button type="button" className="btn btn-primary" disabled onClick={ () => callback({type:"suivant", cible: suivant })}>Suivant</button>) }
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Boutons;